import React from 'react';
import { CreditCardIcon, ZapIcon, ShieldCheckIcon, LockIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PRICE_TODAY, PRICE_FULL } from '../constants/data';
const badges = [{
  icon: CreditCardIcon,
  label: 'Solo Mercado Pago'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}];
interface PriceBlockProps {
  ctaLabel: string;
}
export function PriceBlock({
  ctaLabel
}: PriceBlockProps) {
  return <div className="flex flex-col items-center" data-id="element-213">
      <p className="text-2xl sm:text-3xl line-through" style={{
      color: '#FF3B30'
    }} data-id="element-214">
        {PRICE_FULL}
      </p>
      <p className="mt-2 text-4xl sm:text-5xl lg:text-6xl font-extrabold" style={{
      color: '#00C853'
    }} data-id="element-215">
        🔥 HOY: {PRICE_TODAY}
      </p>

      <div className="mt-8 w-full max-w-md" data-id="element-216">
        <CTAButton label={ctaLabel} data-id="element-217" />
      </div>

      <div className="mt-8 flex flex-wrap items-center justify-center gap-3" data-id="element-218">
        {badges.map(({
        icon: Icon,
        label
      }) => <span key={label} className="inline-flex items-center gap-2 glass px-3 py-2 text-xs sm:text-sm text-white/80" data-id="element-219">
            <Icon className="w-4 h-4" style={{
          color: '#00C853'
        }} aria-hidden="true" data-id="element-220" />
            {label}
          </span>)}
      </div>
    </div>;
}